export enum LocalesEnum {
    EN = 'en-GB',
    NL = 'nl-NL'
}
